const initialStateCmid = {
  cmid: [],
  cmid_updated: false,
};

export default initialStateCmid;